module.exports = __webpack_public_path__ + "static/media/yahya_avatar.b80262e3.png";